export default __webpack_public_path__ + "static/media/wallet-enabled.f8210557.svg";